import styled from "styled-components";

export const Controlers = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: auto 65px auto;
  grid-gap: 5px;
  justify-content: space-between;
  width: 100%;
`;
